import React, { useEffect, memo } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
	SiteType,
	SiteOrder,
	SiteBusinessType,
	Search,
} from '@brainstormforce/starter-templates-components';
import { __ } from '@wordpress/i18n';
import { queryParamDelete, queryNavigation } from '../utils/query-navigation';
import { useFilteredSites } from '../../util/helper-functions';

import './style.scss';
import SiteFiltersCombined from '../site-filters-combined';
import ICONS from '../icons';

const OtherFilters = ( { siteData, setSiteData } ) => {
	const stateValue = useSelector( ( state ) => state );
	const sites = useFilteredSites();
	const dispatch = useDispatch();
	const {
		pageBuilder,
		showTopSearchFilter,
		showOtherFilters,
		filterplan,
		filtersortby,
		siteBusinessType,
		selectedMegaMenu,
		searchTerm,
	} = stateValue;

	const handleSearchClick = ( event ) => {
		event.preventDefault();
		document
			.getElementById( 'astra-sites-search-box' )
			.classList.toggle( 'display-search-box' );
	};

	const handleToggle = ( event ) => {
		const mobileSearchBox = document.getElementById(
			'astra-sites-search-box'
		);
		if (
			mobileSearchBox &&
			! event.target.classList.contains( 'mobile-search-icon' ) &&
			! event.target.classList.contains( 'stc-search-input' )
		) {
			mobileSearchBox.classList.remove( 'display-search-box' );
		}

		if (
			! event.target.classList.contains( 'uael-nav-menu__toggle' ) &&
			! event.target.classList.contains( 'uael-nav-menu-label' ) &&
			! event.target.classList.contains( 'fa-angle-down' ) &&
			document.querySelector( '.uael-active-menu' ) &&
			! event.target.classList.contains( 'fa' ) &&
			! event.target.classList.contains( 'uael-menu-item' ) &&
			! event.target.classList.contains( 'uael-menu-toggle' ) &&
			! event.target.classList.contains( 'uael-has-submenu-container' )
		) {
			document.querySelector( '.uael-active-menu' ).click();
		}
	};
	useEffect( () => {
		document.querySelector( 'body' ).addEventListener( 'click', handleToggle );
		return () =>
			document
				.querySelector( 'body' )
				.removeEventListener( 'click', handleToggle );
	}, [] );

	return showOtherFilters
		? createPortal(
			<>
				<div
					id="st-other-filter"
					className={ `st-other-filters ${
						! showTopSearchFilter ? 'no-bottom-border' : ''
					}` }
				>
					<div className="st-category-filter">
						{ showTopSearchFilter ? (
							<SiteBusinessType
								parent={ siteBusinessType }
								menu={ selectedMegaMenu }
								onClick={ ( event, option, childItem ) => {
									dispatch( {
										type: 'set',
										siteBusinessType: option.ID,
										selectedMegaMenu: childItem.ID,
										searchTerm: childItem.title,
									} );
									queryNavigation(
										'search',
										childItem.title
									);
								} }
							/>
						) : null }
					</div>
					<div className="st-search-box">
						<Search
							apiUrl={ `${ AstraShowcaseVars.api_domain }wp-json/starter-templates/v2/sites-search/?search=${ searchTerm }&page-builder=${ pageBuilder }&type=${ filterplan }` }
							beforeSearchResult={ () => {
								if ( !! searchTerm ) {
									setSiteData( {
										...siteData,
										gridSkeleton: true,
									} );
								}
							} }
							onSearchResult={ ( response ) => {
								const results = [];
								if ( response.success ) {
									if ( response.ids.length ) {
										for ( const id of response.ids ) {
											if ( sites[ id ] ) {
												results[ id ] = sites[ id ];
											}
										}
									}
								}

								setSiteData( {
									...siteData,
									sites: searchTerm ? results : sites,
									gridSkeleton: false,
								} );
							} }
							placeholder={ __(
								'Search',
								'astra-sites-showcase'
							) }
							value={ searchTerm }
							onSearch={ ( event, newSearchTerm ) => {
								if ( newSearchTerm === '' ) {
									queryParamDelete( 'search' );
								} else {
									queryNavigation(
										'search',
										newSearchTerm
									);
								}
								dispatch( {
									type: 'set',
									searchTerm: newSearchTerm,
									filtercategories: '',
									selectedMegaMenu: '',
									siteBusinessType: '',
								} );
								setSiteData( {
									...siteData,
									gridSkeleton: true,
								} );
							} }
						/>
					</div>
					<div className="hide-searchbox">
						<button
							className="st-hiden-searchbox"
							onClick={ handleSearchClick }
						>
							{ ICONS.search }
						</button>
					</div>
					<div
						id="st-showcase-type-order-filter"
						className="st-type-and-order-filters"
					>
						{ pageBuilder !== 'gutenberg' && (
							<SiteType
								value={ filterplan }
								onClick={ ( event, type ) => {
									if ( type.id === '' ) {
										queryParamDelete( 'type' );
									} else {
										queryNavigation( 'type', type.id );
									}
									dispatch( {
										type: 'set',
										filterplan: type.id,
									} );
								} }
							/>
						) }
						<SiteOrder
							value={ filtersortby }
							onClick={ ( event, order ) => {
								dispatch( {
									type: 'set',
									filtersortby: order.id,
								} );
							} }
						/>
						<SiteFiltersCombined />
					</div>
				</div>
			</>,
			document.getElementById( 'astra-sites-filters' )
		)
		: null;
};

export default memo( OtherFilters );
